$('.icon-box-inner').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear'
});

      $('.okq_collection').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 600,
        infinite: true,
        autoplaySpeed: 3000,
        autoplay: true,
        prevArrow: '<svg class="previous_arrow slick-arrow" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 66.91 122.88" style="enable-background:new 0 0 66.91 122.88" xml:space="preserve"><g><path d="M64.96,111.2c2.65,2.73,2.59,7.08-0.13,9.73c-2.73,2.65-7.08,2.59-9.73-0.14L1.97,66.01l4.93-4.8l-4.95,4.8 c-2.65-2.74-2.59-7.1,0.15-9.76c0.08-0.08,0.16-0.15,0.24-0.22L55.1,2.09c2.65-2.73,7-2.79,9.73-0.14 c2.73,2.65,2.78,7.01,0.13,9.73L16.5,61.23L64.96,111.2L64.96,111.2L64.96,111.2z"/></g></svg>',
        nextArrow: '<svg class="next_arrow slick-arrow" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 66.91 122.88" style="enable-background:new 0 0 66.91 122.88" xml:space="preserve"><g><path d="M1.95,111.2c-2.65,2.72-2.59,7.08,0.14,9.73c2.72,2.65,7.08,2.59,9.73-0.14L64.94,66l-4.93-4.79l4.95,4.8 c2.65-2.74,2.59-7.11-0.15-9.76c-0.08-0.08-0.16-0.15-0.24-0.22L11.81,2.09c-2.65-2.73-7-2.79-9.73-0.14 C-0.64,4.6-0.7,8.95,1.95,11.68l48.46,49.55L1.95,111.2L1.95,111.2L1.95,111.2z"/></g></svg>',
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });


window.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(min-width: 750px)').matches) {
    return
  }

  const handleCollapse = (heading) => {
    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed')
      heading.setAttribute('aria-expanded', 'true')
    } else {
      heading.classList.add('block-collapsed')
      heading.setAttribute('aria-expanded', 'false')
    }
  }
  
  document.querySelectorAll('.grid .footer-block__heading').forEach((heading, index) => {
    heading.classList.add('block-collapsed')
    heading.setAttribute('role', 'button')
    heading.setAttribute('aria-expanded', 'false')
    heading.setAttribute('tabindex', '0')

    heading.nextElementSibling.setAttribute('id', `footer-block-index-${index}`)
    heading.setAttribute('aria-controls', `footer-block-index-${index}`)

    heading.addEventListener('click', () => { handleCollapse(heading) })
    heading.addEventListener('keypress',  () => { handleCollapse(heading) })
  });

});

  document.addEventListener('DOMContentLoaded', function () {
            var clickableElements = document.querySelectorAll('.footer-block.grid__item');

            clickableElements.forEach(function (element) {
                element.addEventListener('click', function () {
                    
                    clickableElements.forEach(function (sibling) {
                        if (sibling !== element) {
                            sibling.classList.remove('selected');
                        }
                    });
                  if(element.classList.contains('selected')){
                    element.classList.remove('selected');
                  }else{
                    element.classList.add('selected');
                  }
                    
                    
                });
            });
        });


// $("a#prod_sec").click(function() {
//     $('html,body').animate({
//         scrollTop: $("div#buttontext").offset().top},
//         'slow');
// });
$("a#prod_sec").click(function() {
    $('html,body').animate({
        scrollTop: $("div#buttontext").offset().top
    }, 2000); 
});

// $('.link-deatils_block').hide();
// $('.link-text_block span.linktext_heading').click(function(){
//     $('.link-deatils_block').show(700);
// });

// $('.link-text_block span.cross_icon').click(function(){
//     $('.link-deatils_block').hide(700);
// });


$('.logo_list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
          {
                  breakpoint: 768,
                  settings: 'unslick'
          }
    ]
  });


// function playVideo() {
//     var video = document.getElementById("cgiveaway");
//     // Check if the video element exists
//     if (video) {
//         // Replace the src attribute with the autoplay parameter
//         var vid = document.getElementById("youtube_video").value;
//         video.src = "https://www.youtube.com/embed/" + vid + "?autoplay=1";
//     }
// }

       

// mobileOnlySlider(".logo_list", true, false, 767);
// function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
// 	var slider = $($slidername);
// 	var settings = {
// 		mobileFirst: true,
// 		dots: $dots,
// 		arrows: $arrows,
// 		responsive: [
// 			{
// 				breakpoint: $breakpoint,
// 				settings: "unslick"
// 			}
// 		]
// 	};
// 	slider.slick(settings);
// 	$(window).on("resize", function () {
// 		if ($(window).width() > $breakpoint) {
// 			return;
// 		}
// 		if (!slider.hasClass("slick-initialized")) {
// 			return slider.slick(settings);
// 		}
// 	});
// }